// "all_pages" não usa `value` (equivale ao "All website pages" da VideoWise).
export type RuleOperator = 'equals' | 'not_equals' | 'contains' | 'not_contains' | 'starts_with' | 'ends_with' | 'all_pages';
export type RuleCombinator = 'AND' | 'OR';

export interface RuleCondition {
  type: 'condition';
  operator: RuleOperator;
  value: string;
}

export interface RuleGroupNode {
  type: 'group';
  combinator: RuleCombinator;
  children: RuleNode[];
}

export type RuleNode = RuleCondition | RuleGroupNode;

export function isRuleGroup(node: RuleNode): node is RuleGroupNode {
  return node.type === 'group';
}

export function createEmptyCondition(operator: RuleOperator = 'contains'): RuleCondition {
  return { type: 'condition', operator, value: '' };
}

export function createEmptyGroup(combinator: RuleCombinator = 'OR'): RuleGroupNode {
  return { type: 'group', combinator, children: [createEmptyCondition()] };
}

// Converte o formato antigo (duas listas planas, tudo em OR) pra árvore nova
// — usado só na primeira carga de um widget que ainda não tem url_rules
// salvo, pra ele continuar funcionando sem o lojista precisar reconfigurar.
export function buildRuleTreeFromLegacy(equalValues: string[], containValues: string[]): RuleGroupNode {
  const children: RuleNode[] = [
    ...(equalValues || []).filter(v => v?.trim()).map(v => ({ type: 'condition' as const, operator: 'equals' as const, value: v })),
    ...(containValues || []).filter(v => v?.trim()).map(v => ({ type: 'condition' as const, operator: 'contains' as const, value: v })),
  ];

  return {
    type: 'group',
    combinator: 'OR',
    children: children.length > 0 ? children : [createEmptyCondition()],
  };
}
